// src/routes.js
import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const OpenPositions = lazy(() => import('./pages/OpenPositions'));
// const Scenarios = lazy(() => import('./pages/Scenarios'));
// const Portfolios = lazy(() => import('./pages/Portfolios'));
const AccountsBalance = lazy(() => import('./pages/Accounts/Balance'));
const AccountsList = lazy(() => import('./pages/Accounts/List'));
const TimeSeriesExplorer = lazy(() => import('./pages/TimeSeries/Explorer'));
const FXPlots = lazy(() => import('./pages/Plot/FX'));
const PyFRBUS = lazy(() => import('./pages/PyFRBUS'));
const MacroDemand = lazy(() => import('./pages/MacroDemand'));
const FiscalPressure = lazy(() => import('./pages/FiscalPressure'));
const GcCarry = lazy(() => import('./pages/GcCarry'));
const MQG = lazy(() => import('./pages/MQG'));
const MacroPage = lazy(() => import('./pages/Macro'));
// const Option = lazy(() => import('./pages/Option'));
// const Index = lazy(() => import('./pages/Plot/Index'));
// const Commodities = lazy(() => import('./pages/Plot/Commodities'));
// const Trend = lazy(() => import('./pages/Plot/Trend'));
// const FuturesCl = lazy(() => import('./pages/Plot/FuturesCl'));
// const Sandbox = lazy(() => import('./pages/Plot/Sandbox'));
// const Avtrcn = lazy(() => import('./pages/Strategies/Avtrcn'));
// const Admin = lazy(() => import('./pages/Admin'));

const AppRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/openPositions" element={<OpenPositions />} />
        {/* <Route path="/scenarios" element={<Scenarios />} />
        <Route path="/portfolios" element={<Portfolios />} /> */}
        <Route path="/accounts/balance" element={<AccountsBalance />} />
        <Route path="/accounts/list" element={<AccountsList />} />
        <Route path="/timeseries/explorer" element={<TimeSeriesExplorer />} />
        <Route path="/plot/fx" element={<FXPlots />} />
        <Route path="/pyfrbus" element={<PyFRBUS />} />
        <Route path="/strategies/macro-demand" element={<MacroDemand />} />
        <Route path="/strategies/fiscal-pressure" element={<FiscalPressure />} />
        <Route path="/strategies/gc-carry" element={<GcCarry />} />
        <Route path="/equity/mqg" element={<MQG />} />
        <Route path="/macro" element={<MacroPage />} />
        {/* <Route path="/option" element={<Option />} />
        <Route path="/plot/index" element={<Index />} />
        <Route path="/plot/commodities" element={<Commodities />} />
        <Route path="/plot/trend" element={<Trend />} />
        <Route path="/plot/futures/CL" element={<FuturesCl />} />
        <Route path="/plot/sandbox" element={<Sandbox />} />
        <Route path="/strategies/avtrcn" element={<Avtrcn />} />
        <Route path="/admin" element={<Admin />} /> */}
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
